/**
 * Search-within-map-on-move policy.
 *
 * Keeps a "search within map" (rectangular-area) search in step with the map: once
 * the search is a rectangle, every settled map position searches the new visible
 * area again, so listings, counts and pins always match what the user sees. The URL
 * `coordinates` parameter follows along.
 *
 * Starting a rectangular-area search is not this policy's job: the button, "near me"
 * and URL restore live in searchWithinMap.plugin, and the automatic switch on a pan
 * away from the original area is autoSearchWithinMap.policy.
 *
 * Applies when:
 *  - the mode is rectangularArea; and
 *  - the position is not the initial one, i.e. the first settled position after
 *    start or a location selection, where the page placed the map rather than the user.
 *
 * Decision: `searchRectangle(searchBounds)`. Search bounds are the viewport, expanded
 * at site plan zoom so visible site plans keep their community (see
 * ./sitePlanViewportPadding.js).
 *
 * No gesture is required: once the user chose a rectangle, any camera move refines it.
 * It runs first because nothing else should handle a position while the search is
 * already a rectangle.
 *
 * Pure — no store, map, DOM or RxJS access.
 *
 * @module searchResultsMap/services/searchWithinMapOnMove.policy
 */

import ViewportSearchMode from '../enums/viewportSearchMode';
import { searchRectangle } from './decisions';

export default function createSearchWithinMapOnMovePolicy() {
  function evaluate(snapshot) {
    if (snapshot.mode !== ViewportSearchMode.RectangularArea || snapshot.isInitialPosition) {
      return null;
    }

    return searchRectangle(snapshot.searchBounds);
  }

  return {
    name: 'search-within-map-on-move',
    evaluate,
  };
}
